// @flow
import { UserInfotoolsActionTypes } from './constants';

const INIT_STATE = {
    userInfotools: {},
    listaUsersInfotools: [],
    loading: false,
    error: false,
    formSubmited: false
};

type UserInfotoolsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { userInfotools?: {} | null, listaUsersInfotools?: [] | null, loading?: boolean, +value ?: boolean };

const UserInfotools = (state: State = INIT_STATE, action: UserInfotoolsAction): any => {
    // console.log(action);
    switch (action.type) {
        case UserInfotoolsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case UserInfotoolsActionTypes.GET_USER_INFOTOOLS: {
                    return {
                        ...state,
                        userInfotools: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case UserInfotoolsActionTypes.LIST_USERS_INFOTOOLS: {
                    return {
                        ...state,
                        listaUsersInfotools: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case UserInfotoolsActionTypes.ADD_USER_INFOTOOLS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case UserInfotoolsActionTypes.UPDATE_USER_INFOTOOLS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case UserInfotoolsActionTypes.DELETE_USER_INFOTOOLS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case UserInfotoolsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case UserInfotoolsActionTypes.GET_USER_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        userInfotools: {},
                        loading: false,
                    };
                }
                case UserInfotoolsActionTypes.LIST_USERS_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaUsersInfotools: [],
                        loading: false,
                    };
                }
                case UserInfotoolsActionTypes.ADD_USER_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case UserInfotoolsActionTypes.UPDATE_USER_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case UserInfotoolsActionTypes.DELETE_USER_INFOTOOLS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case UserInfotoolsActionTypes.GET_USER_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case UserInfotoolsActionTypes.LIST_USERS_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case UserInfotoolsActionTypes.ADD_USER_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case UserInfotoolsActionTypes.UPDATE_USER_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case UserInfotoolsActionTypes.DELETE_USER_INFOTOOLS:
            return { ...state, error: false, loading: true };
        case UserInfotoolsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                userInfotools: {},
                listaUsersInfotools: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default UserInfotools;
